import { useEffect, useMemo, useState } from "react";
import { realtimeClient } from "./realtime-client";
import { RealtimeEvents } from "./realtime-events";

export function useRealtimeChannel<T = any>(channelName: string, event = RealtimeEvents.ACTION) {
  const [messages, setMessages] = useState<T[]>([]);
  const realtime = realtimeClient(channelName);

  const channel = useMemo(() => realtime.channels.get(channelName), [channelName]);

  useEffect(() => {
    const handler = (msg: any) => setMessages((prev) => [...prev, msg.data as T]);

    channel.subscribe(event, handler);

    return () => {
      channel.unsubscribe(event, handler);
      realtime.channels.release(channelName);
    };
  }, [channel, channelName, event]);

  const publish = async (data: T) => {
    await channel.publish(event, data);
  };

  return { messages, publish };
}